import EmptyCard from "../../../../../../../atoms/EmptyCard";

export default function VisitTwo() {
  return (
    <>
      <div
        className="empty_wrap"
        style={{
          boxShadow: "0px 0px 20px 0px #0000001A inset",
          backgroundColor: "#DEE5E6",
          borderRadius: "16px",
        }}
      >
        <EmptyCard
          imageHeight={240}
          title="Crew didn’t submit any report"
          description="The crew hasn't provided any work report for this visit yet."
          image="/images/empty-icons/no-active-grey.svg"
        />
      </div>
    </>
  );
}
